import { render, staticRenderFns } from "./SectionHeading.vue?vue&type=template&id=400f73c5&scoped=true"
import script from "./SectionHeading.vue?vue&type=script&lang=js"
export * from "./SectionHeading.vue?vue&type=script&lang=js"
import style0 from "./SectionHeading.vue?vue&type=style&index=0&id=400f73c5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400f73c5",
  null
  
)

export default component.exports